import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';

import TopicPageAsideQuery, {
	type TopicPageAsideQuery as TopicPageAsideQueryQueryType,
} from '../ui/__generated__/TopicPageAsideQuery.graphql';

export const topicAsideResource: RouteResource<
	PreloadedQuery<TopicPageAsideQueryQueryType, Record<string, unknown>>
> = createRelayResource<TopicPageAsideQueryQueryType>({
	getQuery: (routerContext) => {
		const uuid = routerContext.match.params.uuid ?? '';

		return {
			query: TopicPageAsideQuery,
			variables: {
				tagUuid: uuid,
			},
		};
	},
});
